<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div v-if="show">
    <vue-plotly
      id="abc"
      :data="plotData"
      :layout="layout"
      :options="options"
      class="pa-0 ma-0"
    />
  </div>
  <div v-else class="align-center">
    <v-img
      class="align-center"
      max-height="100"
      max-width="65"
      src="/reo_pics/error.png"
    ></v-img>
  </div>
</template>

<script>
import VuePlotly from '@statnett/vue-plotly';
import {mapGetters} from 'vuex';
import {config} from '@/store/config';

export default {
  name: 'hist_impexpgraph_tm_1pmc',
  components: {
    VuePlotly,
  },
  props: [],
  computed: {
    ...mapGetters([
      'get_dsm_result',
      'historyPlotDataTotal',
      'getDsmAppState',
      'app_data',
      'single_product',
      'home_market_code',
    ]),

    plotData: function() {
      let plot_list = [
        {
          y: this.array_value_conversion(
            [
              this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations.results
                .trade_value,
              this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations.results
                .trade_value,
              this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations.results
                .trade_value,
              this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations.results
                .trade_value,
              this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations.results
                .trade_value,
            ],
            null,
          ),

          x: this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
            'dsm_history_total_world_sum'
          ].map(v => v['T_Year']),
          name:
            'Estimated untapped potential  (' +
            this.app_data.exchange_rate['Currency'].slice(0, 3) +
            ' ' +
            (
              (this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                .results.trade_value /
                this.app_data.value_mulitplier['divider']) *
              this.app_data.exchange_rate['TW_FX_Rate']
            ).toFixed(2) +
            ' ' +
            this.app_data.value_mulitplier['prefix'] +
            ')',
          type: 'bar',
          marker: {
            color: config.plot_bar_green,
          },
        },
        {
          y: this.array_value_conversion(
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
              'dsm_history_total_world_sum'
            ].map(v => v['World_ImportVal']),
            'time_weighted',
          ),
          x: this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
            'dsm_history_total_world_sum'
          ].map(v => v['T_Year']),
          name: `World imports of ${this.single_product}`,
          mode: 'lines',
          line: {
            color: config.plot_brown,
            width: config.plot_line_width,
            dash: 'dashdot',
          },
        },
        {
          y: this.array_value_conversion(
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
              'dsm_history_total_world_sum'
            ].map(v => v['HM_ExportVal']),
            'time_weighted',
          ),
          x: this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
            'dsm_history_total_world_sum'
          ].map(v => v['T_Year']),
          name: `${this.codeToMarket(this.home_market_code)} exports of ${
            this.single_product
          } to World`,
          mode: 'lines',
          line: {
            color: config.plot_blue,
            width: config.plot_line_width,
            dash: 'solid',
          },
        },
      ];
      return plot_list;
    },
    show: function() {
      // return this.$store.getters.historyPlotDataTotal['x'][0] > 1 ? true : false;
      return true;
    },
    layout: function() {
      return {
        title: {
          automargin: true,
          text:
            'Total World imports relative to total exports' +
            ' of ' +
            this.single_product +
            '<br>from ' +
            this.codeToMarket(this.home_market_code)+" ("+ this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations.markets_count+ " selected markets)",
          font: {
            size: 10,
            color: 'black',
          },
          yref: 'container',
          x: 0.09,
          y: 0.94,
          yanchor: 'bottom',
          pad: {
            b: 10,
          },
        },
        bargap: 0,
        height: '300',
        width: '350',
        autosize: true,
        margin: {
          l: 50,
          r: 20,
          b: 90,
          t: 55,
          pad: 2,
        },

        xaxis: {
          tickmode: 'linear',
          fixedrange: true,
          tickfont: {
            size: 10,
          },
        },
        yaxis: {
          title: '',
          rangemode: 'tozero',
          fixedrange: true,
          tickfont: {
            size: 10,
          },
          exponentformat:'none'
        },
        legend: {
          orientation: 'h',
          font: {size: 9},
          automargin: true,
        },
        annotations: [
          {
            x: '0.13',
            y: '1',
            xref: 'paper',
            yref: 'paper',
            xanchor: 'right',
            yanchor: 'bottom',
            text:
              this.app_data.value_mulitplier['prefix'] +
              ' ' +
              this.app_data.exchange_rate['Currency'].slice(0, 3),
            showarrow: false,
          },
          {
            xref: 'paper',
            yref: 'paper',
            x: 0.45,
            y: this.$store.state.app.selectedModelName !== 'National' ? -0.49 : -0.52,
            xanchor: 'center',
            yanchor: 'top',
            text: config.CEPII_Source,
            showarrow: false,
            font: {
              family: 'Arial',
              size: 8,
              color: 'rgb(150,150,150)',
            },
          },
        ],
      };
    },
  },
  data: function() {
    return {
      options: {
        responsive: true,
        displayModeBar: false,
      },
    };
  },
};
</script>
